<template>
  <v-icon :icon="['fas', 'n']" />&nbsp;
  <v-icon :icon="['fas', 'e']" />&nbsp;
  <v-icon :icon="['fas', 'w']" />
</template>

<script>
export default {
  name: "NewWord"
}
</script>

<style scoped>

</style>